import React, { useState } from "react";
import { C } from "./theme";

export const AdBanner = ({ slot = "728x90", label = "Publicité" }) => {
  const ads = [
    {annonceur:"Banque Populaire",msg:"Financez vos travaux de copropriété — Taux à partir de 4.5%",cta:"Simuler",color:"#1a56db"},
    {annonceur:"Wafa Assurance",  msg:"Assurance immeuble complète — Devis gratuit en ligne",         cta:"Devis",  color:"#e02020"},
    {annonceur:"Leroy Merlin",    msg:"Matériaux & équipements pour vos travaux — Livraison rapide",  cta:"Voir",   color:"#16a34a"},
  ];
  const [adIdx] = useState(() => Math.floor(Math.random()*3));
  const ad = ads[adIdx];
  return (
    <div className="ad-banner" style={{padding:"10px 18px",display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16,cursor:"pointer"}}
      onClick={() => alert(`Publicité partenaire RésiFlow — ${ad.annonceur}`)}>
      <div style={{display:"flex",alignItems:"center",gap:12}}>
        <div style={{width:32,height:32,borderRadius:8,background:ad.color,display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontSize:13,fontWeight:700}}>
          {ad.annonceur[0]}
        </div>
        <div>
          <p style={{fontSize:12,fontWeight:600,color:C.text}}>{ad.msg}</p>
          <p style={{fontSize:10,color:C.muted,marginTop:1}}>Publicité · {ad.annonceur}</p>
        </div>
      </div>
      <button style={{padding:"5px 12px",borderRadius:8,background:ad.color,color:"#fff",fontWeight:700,fontSize:11,border:"none",cursor:"pointer"}}>{ad.cta} →</button>
    </div>
  );
};
export const downloadBlob = (content, filename, type) => {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export const toCsvValue = (value) => `"${String(value ?? "").replaceAll('"', '""')}"`;
export const stripPdfText = (value) => String(value ?? "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[()]/g, "");

export const downloadCsvReport = (filename, rows) => {
  const csv = rows.map((row) => row.map(toCsvValue).join(",")).join("\n");
  downloadBlob(csv, filename, "text/csv;charset=utf-8;");
};

export const downloadSimplePdf = (filename, title, lines) => {
  const textLines = [title, "", ...lines].map(stripPdfText);
  let y = 760;
  const content = textLines.map((line, index) => {
    const command = `BT /F1 ${index === 0 ? 18 : 11} Tf 50 ${y} Td (${line.slice(0, 90)}) Tj ET`;
    y -= index === 0 ? 28 : 16;
    return command;
  }).join("\n");

  const objects = [];
  const addObject = (body) => {
    objects.push(body);
    return objects.length;
  };

  const catalog = addObject("<< /Type /Catalog /Pages 2 0 R >>");
  const pages = addObject("<< /Type /Pages /Kids [3 0 R] /Count 1 >>");
  const page = addObject("<< /Type /Page /Parent 2 0 R /MediaBox [0 0 595 842] /Contents 4 0 R /Resources << /Font << /F1 5 0 R >> >> >>");
  const stream = addObject(`<< /Length ${content.length} >>\nstream\n${content}\nendstream`);
  const font = addObject("<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica >>");
  void catalog; void pages; void page; void stream; void font;

  let pdf = "%PDF-1.4\n";
  const offsets = [0];
  objects.forEach((objectBody, index) => {
    offsets.push(pdf.length);
    pdf += `${index + 1} 0 obj\n${objectBody}\nendobj\n`;
  });
  const xrefStart = pdf.length;
  pdf += `xref\n0 ${objects.length + 1}\n0000000000 65535 f \n`;
  for (let i = 1; i < offsets.length; i += 1) {
    pdf += `${String(offsets[i]).padStart(10, "0")} 00000 n \n`;
  }
  pdf += `trailer\n<< /Size ${objects.length + 1} /Root 1 0 R >>\nstartxref\n${xrefStart}\n%%EOF`;

  downloadBlob(pdf, filename, "application/pdf");
};

export const apiFetch = async (path, options = {}) => {
  // Cloud-native: API calls go to Cloudflare Workers in production
  // In preview/demo mode, all calls fall back to local demo data
  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.error || data.message || "Erreur API.");
  }

  return data;
};

export const mapApiSession = (payload, residents, prestataires) => {
  const user = payload.user;

  if (user.role === "coproprietaire") {
    const resident =
      residents.find((item) => item.email === user.email) || {
        id: user.id,
        immId: user.residenceId || 1,
        nom: user.lastName || "Utilisateur",
        prenom: user.firstName || "",
        email: user.email,
        tel: "—",
        apt: user.apartmentLabel || "—",
        tantiemes: 0,
        solde: 0,
        statut: "OK",
      };

    return {
      role: "resident",
      data: resident,
      accessToken: payload.accessToken,
      refreshToken: payload.refreshToken,
      source: "api",
    };
  }

  if (user.role === "prestataire") {
    const prestataire =
      prestataires.find((item) => item.email === user.email) || {
        id: user.id,
        nom: user.companyName || `${user.firstName || ""} ${user.lastName || ""}`.trim() || "Prestataire",
        cat: user.serviceCategory || "Services",
        note: 5,
        avis: 0,
        ville: "Maroc",
        desc: "Compte prestataire connecte via l'API locale.",
        tel: "—",
        email: user.email,
        tarif: "—",
        certifié: user.status === "active",
      };

    return {
      role: "prestataire",
      data: prestataire,
      accessToken: payload.accessToken,
      refreshToken: payload.refreshToken,
      source: "api",
    };
  }

  return {
    role: "syndic",
    data: user,
    accessToken: payload.accessToken,
    refreshToken: payload.refreshToken,
    source: "api",
  };
};

/* ── Helpers ── */
export const fmt = n => new Intl.NumberFormat("fr-MA",{style:"currency",currency:"MAD",maximumFractionDigits:0}).format(n);
export const fmtD = d => d ? new Date(d).toLocaleDateString("fr-FR") : "—";
export const stars = n => Array.from({length:5},(_,i) => <span key={i} className="star">{i < Math.floor(n) ? "★" : "☆"}</span>);

export const Tag = ({ s }) => {
  const m = {
    payé:["#d1fae5","#065f46"], impayé:["#fee2e2","#991b1b"], retard:["#fff3cd","#92400e"],
    "en attente":["#e0e7ff","#3730a3"], OK:["#d1fae5","#065f46"], débiteur:["#fee2e2","#991b1b"],
    créditeur:["#d1fae5","#065f46"], "En cours":["#e0e7ff","#3730a3"], Terminé:["#d1fae5","#065f46"],
    Devis:["#fff3cd","#92400e"]
  };
  const [bg, cl] = m[s] || ["#f3f4f6","#374151"];
  return <span className="tag" style={{background:bg,color:cl}}>{s}</span>;
};

export const Kpi = ({ icon, label, value, sub, color, delay = 0 }) => (
  <div className="ch fu" style={{animationDelay:`${delay}ms`,background:C.card,borderRadius:16,padding:"18px 20px",boxShadow:"0 2px 14px rgba(11,19,51,.06)",borderTop:`3px solid ${color}`}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
      <div>
        <p style={{fontSize:11,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:".5px",marginBottom:5}}>{label}</p>
        <p style={{fontSize:24,fontWeight:800,color:C.text,fontFamily:"Syne"}}>{value}</p>
        {sub && <p style={{fontSize:12,color:C.muted,marginTop:3}}>{sub}</p>}
      </div>
      <div style={{width:40,height:40,borderRadius:11,background:`${color}1a`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:19}}>{icon}</div>
    </div>
  </div>
);

export const Btn = ({ onClick, children, color = C.teal, outline = false, disabled = false, small = false, style = {} }) => (
  <button className="btn" onClick={onClick} disabled={disabled}
    style={{padding:small?"6px 13px":"9px 20px",borderRadius:10,fontWeight:600,fontSize:small?12:14,
      background:outline?"transparent":disabled?"#ccc":color,
      color:outline?color:"#fff",border:outline?`1.5px solid ${color}`:"none",
      opacity:disabled?0.7:1,...style}}>
    {children}
  </button>
);

export const Inp = ({ label, value, onChange, type = "text", placeholder = "" }) => (
  <div style={{marginBottom:14}}>
    {label && <label style={{display:"block",fontSize:11,fontWeight:700,color:C.muted,marginBottom:5,textTransform:"uppercase",letterSpacing:".4px"}}>{label}</label>}
    <input className="inp" type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder}
      style={{width:"100%",padding:"10px 14px",borderRadius:10,border:`1.5px solid ${C.border}`,fontSize:14,color:C.text}} />
  </div>
);

export const Sel = ({ label, value, onChange, options }) => (
  <div style={{marginBottom:14}}>
    {label && <label style={{display:"block",fontSize:11,fontWeight:700,color:C.muted,marginBottom:5,textTransform:"uppercase",letterSpacing:".4px"}}>{label}</label>}
    <select className="inp" value={value} onChange={e => onChange(e.target.value)}
      style={{width:"100%",padding:"10px 14px",borderRadius:10,border:`1.5px solid ${C.border}`,fontSize:14,color:C.text,background:"#fff"}}>
      {options.map(o => <option key={o.v || o} value={o.v || o}>{o.l || o}</option>)}
    </select>
  </div>
);

/* ══════════════════════════════════════
   AUTH SCREEN — Connexion + Inscription
══════════════════════════════════════ */
export const CODES_RESIDENCE = {
  "LES-ORG-2024": {immId:1, nom:"Résidence Les Orangers"},
  "AL-AMAL-2024": {immId:2, nom:"Résidence Al Amal"},
  "RYAD-MKN-2024":{immId:3, nom:"Résidence Ryad"},
};

// Re-exports for convenience
export { getAppCopy } from "./i18n";
export { INIT_NOTIFS } from "./data";
